'use es6';

import { createSelector } from 'reselect';
import { Set as ImmutableSet } from 'immutable';
import { getPixels } from './AudiencesSelectors';
import { getAdAccounts } from './AccountsSelectors';
import PixelRecord from 'AdsUI/records/audiences/PixelRecord';
import pixelsForInstallByNetwork from 'ads-account-connection/lib/pixelsForInstallByNetwork';
import { getAdAccountFromProps } from './PropsSelectors';
import { getHubSpotUserId } from './AuthSelectors';
import { getAllPermissions } from './AccountsSelectors';
import PixelAdAccount from 'AdsUI/records/ad-accounts/PixelAdAccount';
export const getPixelsForInstallation = createSelector(getAdAccounts, getPixels, (adAccounts, pixels) => pixelsForInstallByNetwork(adAccounts, pixels, PixelRecord));
export const isPixelInstalledForAdAccount = createSelector(getPixels, getAdAccountFromProps, (pixels, {
  accountId,
  network
}) => pixels.some(pixel => pixel.installed && pixel.accountId === accountId && pixel.adNetwork === network));
export const getPixelAdAccounts = createSelector(getAdAccounts, getHubSpotUserId, getAllPermissions, (adAccountsOverview, hubSpotUserId, permissions) => {
  return adAccountsOverview.map(adAccount => {
    const myPermissions = permissions.getIn([adAccount.network, adAccount.accountId], ImmutableSet()).find(perm => perm.hubSpotUserId === hubSpotUserId);
    return PixelAdAccount.fromAccountOverview(adAccount, !!myPermissions, !!myPermissions && !!myPermissions.permissions && myPermissions.permissions.canCreateAudiences);
  });
});